/**
 * Common error codes across all services
 * @since 1.0.0
 */
export var FirebaseKitErrorCode;
(function (FirebaseKitErrorCode) {
    // General errors
    FirebaseKitErrorCode["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    FirebaseKitErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    FirebaseKitErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    FirebaseKitErrorCode["UNAVAILABLE"] = "UNAVAILABLE";
    FirebaseKitErrorCode["INTERNAL"] = "INTERNAL";
    // App Check errors
    FirebaseKitErrorCode["APP_CHECK_TOKEN_EXPIRED"] = "APP_CHECK_TOKEN_EXPIRED";
    FirebaseKitErrorCode["APP_CHECK_PROVIDER_ERROR"] = "APP_CHECK_PROVIDER_ERROR";
    // AdMob errors
    FirebaseKitErrorCode["AD_LOAD_FAILED"] = "AD_LOAD_FAILED";
    FirebaseKitErrorCode["AD_SHOW_FAILED"] = "AD_SHOW_FAILED";
    FirebaseKitErrorCode["AD_NOT_READY"] = "AD_NOT_READY";
    // Remote Config errors
    FirebaseKitErrorCode["CONFIG_FETCH_FAILED"] = "CONFIG_FETCH_FAILED";
    FirebaseKitErrorCode["CONFIG_UPDATE_FAILED"] = "CONFIG_UPDATE_FAILED";
    // Platform errors
    FirebaseKitErrorCode["NOT_SUPPORTED_ON_PLATFORM"] = "NOT_SUPPORTED_ON_PLATFORM";
    FirebaseKitErrorCode["WEB_NOT_SUPPORTED"] = "WEB_NOT_SUPPORTED";
})(FirebaseKitErrorCode || (FirebaseKitErrorCode = {}));
//# sourceMappingURL=definitions.js.map